import { useTutorial } from "@/hooks/useTutorial";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Sparkles, X } from "lucide-react";

export function SemanticSearchCallout() {
  const { showSemanticSearchCallout, setShowSemanticSearchCallout } = useTutorial();

  if (!showSemanticSearchCallout) {
    return null;
  }

  return (
    <Card className="border-primary/30 bg-primary/5 animate-in slide-in-from-top-2 duration-300">
      <CardContent className="py-4">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-start gap-3">
            <div className="p-2 rounded-lg bg-primary/10 text-primary flex-shrink-0">
              <Sparkles className="h-5 w-5" />
            </div>
            <div>
              <h4 className="font-semibold text-foreground mb-1">
                ¡Eso es búsqueda semántica con IA!
              </h4>
              <p className="text-sm text-muted-foreground">
                Fijate que los resultados no contienen exactamente las palabras que buscaste. 
                DoctIA entiende el <span className="font-medium text-foreground">concepto</span>, 
                no solo las palabras clave. ¡No más búsquedas que no llevan a ningún lado!
              </p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="icon"
            className="h-6 w-6 flex-shrink-0"
            onClick={() => setShowSemanticSearchCallout(false)}
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
